import Insights, { InsightsDispatchProps, InsightsOwnProps, InsightsStateProps } from 'components/features/insights/Insights/Insights'
import { GuardsParam } from 'interfaces/guards'
import { connectStaleableLoadable } from 'helpers/loadableHelpers'
import { peergroupsGuard } from 'guards/globalGuards'
import { createInsightsGuard } from 'guards/insightGuards'
import { isPlacementDataPresentSelector, createVisibleInsightsByPlacementSelector } from 'selectors/insightsSelectors'
import { insightShownActionCreator, setActiveInsightActionCreator } from 'actions/insightsActions'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { createSelector } from 'reselect'
import { Insight } from 'interfaces/insights'

const createMapStateToProps = () => createSelector(
  createVisibleInsightsByPlacementSelector<Insight>(),
  isMobileSelector,
  (insights, isMobile): InsightsStateProps => ({
    insights,
    isMobile,
  })
)

const mapDispatchToProps: InsightsDispatchProps = {
  onInsightShown: insightShownActionCreator,
  setActiveInsight: setActiveInsightActionCreator,
}

const createInsightsGuards: GuardsParam<InsightsOwnProps> = () => [
  peergroupsGuard,
  createInsightsGuard(),
]

export default connectStaleableLoadable<
  InsightsStateProps,
  InsightsDispatchProps,
  InsightsOwnProps
>(createInsightsGuards, isPlacementDataPresentSelector)(createMapStateToProps, mapDispatchToProps)(Insights)
